import type { ReactNode } from 'react';

import { type ClassValue, clsxm } from '@vs-shop/utils';

export const contentColumnClasses =
  'px-content-safe-padding-sm lap:px-content-safe-padding-lg mx-auto max-w-(--container-3xl)';

export type ContainerProps = {
  classNameWrapper?: ClassValue;
  classNameInner?: ClassValue;
  children: ReactNode;
};

export function Container({ classNameWrapper, classNameInner, children }: ContainerProps) {
  return (
    <div data-slot="container" className={clsxm(classNameWrapper)}>
      <div data-slot="container-inner" className={clsxm(contentColumnClasses, classNameInner)}>
        {children}
      </div>
    </div>
  );
}
